export default __webpack_public_path__ + "static/media/Q4-1.bf134c3b.jpg";